import React from "react";

const ChatMessageContext = React.createContext<{ id?: string }>({});

export default ChatMessageContext;
